import { render, staticRenderFns } from "./dialog-change-spam-state.vue?vue&type=template&id=3fa2d188&scoped=true&"
import script from "./dialog-change-spam-state.vue?vue&type=script&lang=js&"
export * from "./dialog-change-spam-state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa2d188",
  null
  
)

export default component.exports